import { chainName } from '@emberswap/emberswap-sdk2/dist/constants'
import { FC, ReactElement } from 'react'
import { useNetwork, useSwitchNetwork } from 'wagmi'

import { CheckerButton } from './types'

export interface NetworkProps extends CheckerButton {
  chainId: number | undefined
}

export const Network: FC<NetworkProps> = ({
  chainId,
  children,
  ...rest
}): ReactElement<any, any> | null => {
  const { chain } = useNetwork()
  const { switchNetwork } = useSwitchNetwork()

  if (!chainId) return null

  if (chain?.id !== chainId)
    return (
      <div className="opacity-80 hover:opacity-100 flex font-medium items-center animate-border hover:animate-none group-one-hover:animate-none group-hover:animate-none duration-500 ease-in-out gap-2 rounded-2xl  bg-gradient-to-r from-gradientborderone via-gradientbordertwo to-gradientborderthree bg-[length:200%_200%] p-[1px] transition  focus:outline-none">
        <button
          className="px-4 h-[52px] rounded-2xl text-base font-semibold relative whitespace-nowrap bg-secondarybg  min-w-[260px]  flex items-center justify-center w-full"
          onClick={() => switchNetwork && switchNetwork(chainId)}
          {...rest}
        >
          Switch to {chainName[chainId]}
        </button>
      </div>
    )

  return <>{children}</>
}
